import axios from "../axiosInstance";
import { InitiateJoinResponse } from "../initiateJoin/types";

export const initiateJoinByContactId = async (
  hubspotContactId: string,
): Promise<InitiateJoinResponse> => {
  const response = await axios.post<InitiateJoinResponse>(
    `/api/public/join/init/${hubspotContactId}`,
  );
  return response.data;
};
